import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
import SecBanner from "../../component/Page/SecBanner";
import SecBlog from "../../component/Page/SecBlog";

const Index = (props) => {
  return (
    <Fragment>
      <div className="overflow-hidden font-poppins">

        <div className="bg__blue-2">
          <Navbar />

          <section className="position-relative">
            <img src="./../images/Group 24760.png" className="images__head-top d-block" alt="" />
            <div className="container position-relative z-2">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <h1 className="semi-bold font__size--72 text__70-1024 text__70-md text__70-sm mb-0">ListoPago</h1>
                  <p className="medium font__size--26 text__12-1024 color__gray-1 lh-2 my-4">La app que convierte <strong>cada foto de comprobante</strong> en una <strong>transacción registrada</strong> — <strong>en segundos</strong>. Para <strong>dueños de negocios</strong> que ya no quieren <strong>perder horas revisando transferencias</strong>.</p>

                  <a
                    href="https://play.google.com/store/apps/details?id=com.listopago.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-inline-block semi-bold font__size--14 text__14-1024 btn btn__purple px-4 color__white shadow ml-auto text-capitalize rounded__12 mb-5 text-decoration-none"
                  >
                    <div className="d-flex align-items-center">
                      <img src="./../images/Game.png" className="mr-2" alt="" />
                      Prueba gratis ahora
                    </div>
                  </a>

                  <div className="d-flex flex-wrap flex-md-nowrap align-items-center pt-md-5">
                    <span className="ml-2 semi-bold font__size--16 text__20-1024">
                      ✅ 15 días gratis · Sin tarjeta · Sin suscripción · Tu decides si pagas
                    </span>
                  </div>
                  <div className="d-flex flex-wrap align-items-center mt-3" style={{ gap: '12px' }}>
                    <span className="semi-bold font__size--14 text__14-1024 rounded-pill px-3 py-1" style={{ backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)' }}>
                      🇨🇴 Colombia · Wompi (PSE, Nequi, Bancolombia)
                    </span>
                    <span className="semi-bold font__size--14 text__14-1024 rounded-pill px-3 py-1" style={{ backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)' }}>
                      🇻🇪 Venezuela · Binance Pay (USDT)
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />


        <section className="position-relative">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 position__initial">
                <img src="./../images/Illustration1.png" className="images__about-left" alt="" />
              </div>
              <div className="col-lg-6 mobile-top">
                <h2 className="semi-bold font__size--72 text__70-1024 text__70-md text__70-sm mb-4">Somos ListoPago</h2>
                <p className="medium font__size--18 text__12-1024 color__gray-1 lh-2">Construimos tecnología para que los <strong>emprendedores de Colombia 🇨🇴 y Venezuela 🇻🇪</strong> <strong>trabajen menos y ganen más</strong>. Nuestra app <strong>automatiza</strong> lo que antes tomaba horas:</p>
                <ul className="medium font__size--18 text__12-1024 color__gray-1 mb-4 lh-2">
                  <li>Concilia transferencias de <strong>Bancolombia, Nequi, Pago Móvil</strong> y más.</li>
                  <li>Organiza tus <strong>ingresos y egresos</strong> por día, turno o mes.</li>
                  <li>Todo desde tu <strong>celular</strong>.</li>
                </ul>

                <NavLink to="/about" className="d-inline-block semi-bold font__size--16 text__16-1024 btn btn__purple px-4 color__white shadow ml-auto text-capitalize rounded__12">
                  Conoce mas de nosotros
                </NavLink>
              </div>
            </div>
          </div>
        </section>


        <section>
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx mb-4">🔹 Elige tu forma de trabajar</h2>
              <p className="medium font__size--18 text__18-1024 color__gray-1 lh-2 mb-0">No necesitas ser experto. Solo toma foto y ListoPago hace el resto.</p>
            </div>

            <div className="row">
              <div className="col-lg-10">
                <ul className="medium font__size--18 text__18-1024 color__gray-1 lh-2 list-unstyled mb-0">
                  <li className="mb-4">
                    <strong>📅 Historial diario inteligente:</strong> Ve todas tus transacciones agrupadas por fecha — y ahora filtra por banco (Nequi, Bancolombia, Daviplata, etc.) para saber de dónde viene cada dinero.
                  </li>
                  <li className="mb-4">
                    <strong>⏰ Por turnos avanzado:</strong> Controla ventas y gastos por mañana, tarde, noche y madrugada — y filtra por rango horario (ej. "8:00 a.m. – 2:00 p.m.") para ver exactamente qué pasó en tu turno.
                  </li>
                  <li className="mb-4">
                    <strong>📝 Notas personalizadas:</strong> Al subir una foto, agrega una nota: "Transferencia de Juan - Salchipapas", "Pago proveedor - Papel higiénico". ¡Nunca más olvidarás para qué fue ese $15.000!
                  </li>
                  <li className="mb-4">
                    <strong>💸 Egresos incluidos:</strong> Ahora también llevas tus gastos con el mismo flujo: toma foto → ListoPago extrae → organiza → cierra caja sin errores.
                  </li>
                  <li className="mb-4">
                    <strong>📊 Resumen mensual inteligente:</strong> Visualiza tu crecimiento con un calendario interactivo: días con más ingresos, gastos recurrentes, tendencias… todo en un vistazo.
                  </li>
                </ul>
                <p className="semi-bold font__size--20 text__20-1024 lh-2 text-center mt-5 mb-0" style={{ color: 'rgb(17, 112, 223)' }}>
                  ✨ ListoPago no solo registra — entiende tu negocio.
                </p>
              </div>
            </div>
          </div>
        </section>


        <section className="position-relative">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 order-lg-1 order-12">
                <h2 className="semi-bold font__size--64 text__65-1024 text__65-md text__65-sm mb-4">ListoPago: cierra caja sin estrés</h2>
                <p className="medium font__size--18 text__12-1024 color__gray-1 lh-2">Automatiza la <strong>conciliación de transferencias</strong> y lleva el control de tus <strong>ingresos y egresos</strong> desde el celular. <strong>Menos tiempo en comprobantes</strong>, <strong>más tiempo para tu negocio</strong>.</p>

                <a
                  href="https://play.google.com/store/apps/details?id=com.listopago.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-inline-block semi-bold font__size--16 text__16-1024 btn btn__purple px-4 color__white shadow ml-auto text-capitalize rounded__12 text-decoration-none"
                >
                  <div className="d-flex align-items-center">
                    <img src="./../images/Game1.png" className="mr-2" alt="" style={{ width: "24px", height: "auto" }} />
                    Prueba gratis
                  </div>
                </a>
              </div>
              <div className="col-lg-6 order-1 order-lg-12 position__initial">
                <img src="./../images/Group 24790.png" className="images__about-right" alt="" />
              </div>
            </div>
          </div>
        </section>


        <section>
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="semi-bold font__size--72 text__70-1024 text__70-md text__70-sm mb-3">🔹 ¿Para quién es ListoPago?</h2>
              <p className="medium font__size--20 text__20-1024 color__gray-1 lh-2 mb-0">ListoPago es para ti si:</p>
            </div>

            <div className="row mb-4 justify-content-center">
              <div className="col-12 col-lg-10 px-3 px-lg-0">
                <ul className="medium font__size--18 text__18-1024 color__gray-1 lh-2 list-unstyled mb-0 pl-0">
                  <li className="mb-3">🇨🇴 Eres dueño de una tienda, cafetería, panadería o negocio en <strong>Colombia</strong> y recibes transferencias por Nequi, Bancolombia o Daviplata.</li>
                  <li className="mb-3">🇻🇪 Tienes un negocio en <strong>Venezuela</strong> y manejas pagos por <strong>Pago Móvil</strong>.</li>
                  <li className="mb-3">Recibes +10 transferencias al día y pierdes horas revisándolas.</li>
                  <li className="mb-3">Quieres cerrar caja sin estrés, sin errores ni cuentas mal hechas.</li>
                  <li className="mb-3">Prefieres una app simple, rápida y hecha para ti — no para grandes empresas.</li>
                  <li className="mb-3">Y sí, también necesitas llevar tus gastos (porque el negocio no solo tiene ingresos).</li>
                </ul>
              </div>
            </div>

            <div className="text-center">
              <a
                href="https://play.google.com/store/apps/details?id=com.listopago.app"
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block semi-bold font__size--16 text__16-1024 btn btn__purple px-4 color__white shadow text-capitalize rounded__12 mb-3 text-decoration-none"
              >
                🚀 15 días gratis de prueba. Sin suscripción.
              </a>
              <p className="medium font__size--18 text__18-1024 color__gray-1 lh-2 mb-0">
                Porque tu tiempo merece más que una app… merece tranquilidad.
              </p>
            </div>
          </div>
        </section>

        {/* Banner Venezuela */}
        <section className="py-4" style={{ backgroundColor: '#eef6ff', borderTop: '1px solid #d0e8ff', borderBottom: '1px solid #d0e8ff' }}>
          <div className="container text-center">
            <p className="mb-0 semi-bold font__size--16 text__16-1024" style={{ color: '#032B77' }}>
              🇻🇪 <strong>¡Ahora disponible en Venezuela!</strong> · Registra tus Pagos Móviles al instante · Planes desde <strong>4.99 USDT/mes</strong> · Pago con <strong>Binance Pay</strong>
            </p>
          </div>
        </section>

        <SecBlog title="Nuestros Planes" />

        <SecBanner />

        <Footer />
      </div >
    </Fragment >
  );
};

export default Index;
